module.exports = "<table class=\"table table-bordered table-sm text-center\">\r\n\r\n  <thead class=\"thead-light\">\r\n    <tr>\r\n      <th>Logradouro</th>\r\n      <th>N&uacute;mero</th>\r\n      <th>Complemento</th>\r\n      <th>Bairro</th>\r\n      <th>CEP</th>\r\n      <th>Cidade</th>\r\n      <th>Estado</th>\r\n      <th>Editar</th>\r\n      <th>Remover</th>\r\n    </tr>\r\n  </thead>\r\n\r\n  <ng-content></ng-content>\r\n\r\n</table>"


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/endereco/endereco.component.html
// module id = ../../../../../src/app/comum/components/endereco/endereco.component.html
// module chunks = main